export const ROLE_TYPE = {
	ADMIN: 'admin',
	STUDENT: 'student'
}

export const URLPath = {
	ROOT: '/',
	ADMIN: '/admin',
	DASHBOARD: '/admin/dashboard',
	COURSE_PLAYER: '/course-player',
	ASSIGNMENTS: '/admin/assignments',
	VIDEOS: '/admin/videos',
	QUIZZES: '/admin/quizzes',
	ASSIGNMENT_MARK: '/admin/assignment-mark'
}

export const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		background: 'rgb(74 72 72)',
		maxWidth: '1000px', // adjust to desired width
		maxHeight: '90vh', // adjust to desired height
		minWidth: '800px'
	},
};
